import { useEffect } from 'react';

import BurgerMenuIcon from '~/assets/icons/BurgerMenu';
import useModal from '~/hooks/useModal';

import MobileMenuDrawer from './MobileMenuDrawer';
import type { MobileMenuProps } from './types';

export default function MobileMenu({
  menu,
  mobileMenuIsOpen,
  setMobileMenuIsOpen
}: MobileMenuProps) {
  const [isOpen, setOpen, setClosed] = useModal();

  useEffect(() => {
    if (mobileMenuIsOpen && setOpen) setOpen();
  }, [mobileMenuIsOpen, setOpen]);

  return (
    <div className="flex h-full cursor-pointer items-center justify-center lg:hidden">
      {!isOpen && (
        <button
          type="button"
          aria-label="Open menu"
          className="tap-target"
          onClick={() => {
            setMobileMenuIsOpen(!mobileMenuIsOpen);
          }}
        >
          <BurgerMenuIcon width="19" height="19" fill="#ffffff" />
        </button>
      )}

      <div
        className={`block h-full cursor-pointer ${
          isOpen
            ? 'visible'
            : 'pointer-events-none invisible transition-[visibility] delay-300 duration-0'
        }`}
      >
        <MobileMenuDrawer
          menu={menu}
          setClosed={setClosed}
          setMobileMenuIsOpen={setMobileMenuIsOpen}
          mobileMenuIsOpen={mobileMenuIsOpen}
        />
      </div>
    </div>
  );
}
